<template>
  <div class="cash">
    <van-sticky v-if="showBar==1">
      <van-nav-bar
        :border="false"
        :safe-area-inset-top="true"
        title="预约报名"
        left-arrow
        @click-left="onClickLeft"
      />
    </van-sticky>

    <div class="huodong-div">
      <div class="huodong-img">

        <img class="btn-rule" @click="onRule"
             src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/btn_huodongguize.png">

        <div class="cash-time">
          <!--          <p>万元大奖开奖倒计时</p>-->
          <!--          <p>{{ time }}</p>-->
        </div>

        <div class="bottom-img">
          <img v-if="signFlag==0"
               src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/btn_choujiang@2x.png"
               class="btn_fab"
               @click="sign">
          <img v-else
               src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/btn_choujiang.png" class="btn_fab"
               @click="sign">
          <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/btn_yaoqing@2x.png" class="btn_fab"
               @click="toShare">
        </div>

        <div class="tip-cash-div">
          <div class="tip-cash">
            <div class="tip-cash-content" style="display: flex">
              <img class="dajiang"
                   src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/icon_dajiang@2x.png">

              <div style="margin: auto">
                <template v-if="tenThousandMobile">
                  <p class="user">恭喜用户{{ tenThousandMobile }}</p>
                  <p class="tip-ten" style="color: red">中得一万元现金大奖</p>
                </template>
                <template v-else>
                  <template v-if="status === 0">
                    <p class="tip">活动已结束</p>
                  </template>
                  <template v-if="status === 1">
                    <p class="user">万元大奖开奖倒计时</p>
                    <p class="tip">{{ time }}</p>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="hist-list">
          <div class="hist-div">
            <div class="hist-content">

              <div class="share-title-div">
                <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/title_prize@2x.png"
                     class="share_title_yaoqing">
              </div>

              <div class="prize-content">
                <van-row gutter="10">
                  <van-col span="24">
                    <img style="width: 100%; height: auto"
                         src="../../../assets/images/activity/prize_1.png">
                  </van-col>
                  <van-col span="24">
                    <img style="width: 100%; height: auto"
                         src="../../../assets/images/activity/prize_2.png">
                  </van-col>

                  <van-col span="12">
                    <img style="width: 100%; height: auto"
                         src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/prize_3.png">
                  </van-col>
                  <van-col span="12">
                    <img style="width: 100%; height: auto"
                         src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/prize_4.png">
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </div>

        <div class="hist-list" :class="winsFlag===0 ? 'bt-60' : ''">
          <div class="hist-div bt-20">
            <div class="hist-content">

              <div class="share-title-div">
                <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/title_gonglue@2x.png"
                     class="share_title_yaoqing">
              </div>

              <div class="content" style="display: flex">
                <img class="no-1" src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/no_1.png">
                <p class="f15 w-100">快去实名认证，实名认证后中奖几率更大哦</p>
                <img class="right-icon" v-if="authFlag == 0" @click="toAuth"
                     src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/btn_qushiming@2x.png">
                <img class="right-icon" v-if="authFlag == 1"
                     src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/profile_icon_shiming.png">
              </div>

              <div class="content" style="display: flex">
                <img class="no-1" src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/no_2.png">
                <p class="f15 w-100">快去邀请工友，邀请越多，奖励机会越多</p>
                <img class="right-icon" @click="toShare"
                     src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/btn_yaoqing.png">
              </div>

              <div class="content" style="display: flex">
                <img class="no-1" src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/no_3.png">
                <p class="f15 w-100">完善个人信息、发布招工信息、拨打招工电话也可以提高中奖几率哦</p>
              </div>

            </div>
          </div>
        </div>

        <div v-if="winsFlag===1" class="hist-list bt-60">
          <div class="hist-div" style="background-color: #FFFFFF">
            <div class="hist-content">

              <div class="share-title-div">
                <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/title_mingdan.png"
                     class="share_title_yaoqing">
              </div>

              <div class="prize-time"></div>

              <div class="list-content" @scroll="handleScroll($event)">

                <div class="coins-list">
                  <ul v-if="list.length>0">
                    <li v-for="(item, index) in list" :key="index">
                      <div style="display: flex">
                        <img class="list-icon" v-if="item.prizeLevel == 0"
                             src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/icon_hongbao@2x.png">
                        <img class="list-icon" v-else
                             src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/share_icon_yaogongbi@2x.png">
                        <p>用户{{
                            item.mobile + '获得' + item.prizeName
                          }}<span>{{ item.prizeNum + item.prizeUnit }}</span>
                        </p>
                      </div>
                    </li>
                  </ul>
                  <div v-else style="text-align: center">
                    <p class="list-tip">开奖中...</p>
                    <p class="list-tip-time">公示中奖时间：今日10:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isIOS" class="iOS-rule-tip">
          <span class="iOS-rule-tip-text">本活动兑换奖品由邀工网提供，与Apple Inc.无关。</span>
        </div>
      </div>
    </div>

    <van-overlay :show="shareShow" @click="shareShow = false" z-index="999">
      <div class="share-popup" @click.stop>
        <van-icon color="#d3d3d3" style="float: right" name="close" @click="shareShow=false"/>
        <div class="share-popup-content">
          <div class="share-title">
            每邀请一位工友点击使用邀工网，即可获得5个邀工币
          </div>
          <div class="share-tip" style="text-align: center;color: #999999FF">
            分享到
          </div>
          <div class="share-icon" style="text-align: center">
            <van-row>
              <van-col span="8" @click="toWechat">
                <img src="../../../assets/images/coins/share_icon_wechat.png">
                <div class="text">微信</div>
              </van-col>
              <van-col span="8" @click="toPengyouquan">
                <img src="../../../assets/images/coins/share_icon_pengyouquan.png">
                <div class="text">朋友圈</div>
              </van-col>
              <van-col span="8" @click="toMianduimian">
                <img src="../../../assets/images/coins/share_icon_mianduimian.png">
                <div class="text">我的推广码</div>
              </van-col>
            </van-row>
          </div>
          <div class="share-tip" style="text-align: center">
            <a @click="toInvitationRule">
              <van-icon name="question-o"/>
              邀请好友规则
            </a>
          </div>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="signShow" @click="signShow = false" z-index="999">
      <div class="overlay-tip" @click.stop>
        <div class="overlay-tip-title">
          <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/title_wenxintishi@2x.png">
        </div>

        <div class="overlay-tip-text">
          <p>点击【参与抽奖】按钮</p>
          <p>参与万元中大奖活动，</p>
          <p>邀请更多好友可以提高中奖机率</p>
        </div>

        <van-button class="overlay-tip-btn" round color="#FFB111FF" @click="sign">参与抽奖</van-button>
      </div>
      <van-icon class="btn-tip-close" color="#d3d3d3" name="close" @click="signShow=false"/>
    </van-overlay>

    <van-overlay :lock-scroll="false" :show="ruleShow" @click="closeRule" z-index="999">
      <div class="overlay-tip overlay-rule" @click.stop>
        <div class="overlay-tip-title">
          <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/title_huodongguize.png">
        </div>

        <div class="rule-title">
          <van-row>
            <van-col span="12">
              <div :class="checked === 0 ? 'checked' : ''" @click="checked=0">参与记录</div>
            </van-col>
            <van-col span="12">
              <div :class="checked === 1 ? 'checked' : ''" @click="checked=1">活动规则</div>
            </van-col>
          </van-row>
        </div>

        <div v-show="checked === 0" class="overlay-tip-text rule-text my-wins" style="text-align: left">
          <ul v-if="myWins.length>0">
            <li v-for="(win, index) in myWins" :key="index">
              <div>{{ win.signDate }}
                <template v-if="win.drawFlag === 1">
                  <template v-if="win.prizeFlag === 1">
                    <span style="float: right">
                    <span v-if="win.prizeLevel === 0">获得特等奖</span>
                    <span v-else-if="win.prizeLevel === 1">获得一等奖</span>
                    <span v-else-if="win.prizeLevel === 2">获得二等奖</span>
                    <span v-else-if="win.prizeLevel === 3">获得三等奖</span>
                    ：<span>{{ win.prizeName + win.prizeNum + win.prizeUnit }}</span>
                      </span>
                  </template>
                  <template v-else>
                    <span style="float: right">未中奖</span>
                  </template>
                </template>
                <template v-else-if="win.drawFlag === 0">
                  <span style="float: right">待开奖</span>
                </template>
                <template v-else-if="win.drawFlag === -1">
                  <img class="btn_qubaoming" @click="sign"
                       src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/btn_qubaoming.png">
                </template>
              </div>
            </li>
          </ul>
          <div v-else style="width: 100%; text-align: center;color: #999999">
            您还未参与活动
          </div>
        </div>

        <div v-show="checked === 1" class="overlay-tip-text rule-text" style="text-align: left">
          <p> 1、用户登录成功后可报名参加活动；</p>
          <p> 2、新老用户均可参与本活动；</p>
          <p> 3、同一个用户不同身份每天仅可报名参加1次；</p>
          <p> 4、用户每天参与活动后可通过实名认证和邀请新用户增加中奖几率；</p>
          <p> 5、在活动页面“中奖记录”中可查看当前用户参与活动和中奖的记录；</p>
          <p> 6、用户中奖后对应奖品将发放到报名时所使用的账号对应的身份下；</p>
          <p> 7、本活动将根据用户反馈、活动效果等多方面因素，不定期对活动形式、活动奖品、活动周期、兑换规则等进行优化调整，具体以页面实际展示为准；</p>
          <p> 8、获取到的邀工币奖品不可折现，不可转赠，仅用于邀工网平台内部使用；</p>
          <p> 9、本活动最终解释权归邀工网平台所有；</p>
          <p> 10、如发现用户存在恶意违规行为，邀工网平台有权取消其活动资格，收回所有奖品，并予以处罚。如对平台造成损失的，将按照法律规定追究其相关责任；</p>
          <p> 11、邀工网《用户协议》、《隐私政策》等平台规范同样适用于本活动，活动规则及相关条款与其相冲突的，以本活动规则为准。本活动规则及相关条款未约定的内容，仍以邀工网《用户协议》、《隐私政策》等平台规范为准；</p>
          <p> 12、如用户对活动及其相关规则有任何疑问或意见，请通过平台内“用户反馈”功能进行反馈或拨打客服电话：400-0900-190（9:00-18:00），我们将会有专人尽快处理；</p>
          <p> 13、本规则自发布之日起立即生效。</p>
          <p v-if="isIOS"> 14、本活动兑换奖品由邀工网提供，与Apple Inc.无关。</p>
        </div>

      </div>

      <van-button size="small" block class="btn-close" color="#ffffff" round style="background-color: rgba(0,0,0,0)"
                  plain>我知道了
      </van-button>
    </van-overlay>

    <van-overlay :show="show" @click="overlayHide" z-index="999">
      <div class="prize-num-tip">
        <img class="prize-num-img"
             src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/tanchuang_wanyuan.png">

        <div class="prize-num" style="position: absolute">
          <div class="prize-ten-time">中奖日期：{{ prizeTime }}</div>

          <van-button
            @click="overlayHide"
            size="small" block
            class="btn-num-close" color="#ffffff" round
            style="background-color: rgba(0,0,0,0)"
            plain>我知道了
          </van-button>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="show1" @click="overlayHide" z-index="999">
      <div class="prize-num-tip">
        <img class="prize-num-img"
             src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/tanchuang_yaogongbi@2x.png">

        <div class="prize-num" style="position: absolute">
          <p>{{ prizeVal }}</p>
          <div class="prize-num-time">中奖日期：{{ prizeTime }}</div>
          <a @click="toMingXi">
            邀工币已到账，前往查看
            <van-icon color="#f5afa9" name="arrow"/>
          </a>

          <van-button
            size="small" block
            class="btn-num-close" color="#ffffff" round
            style="background-color: rgba(0,0,0,0)"
            plain>我知道了
          </van-button>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="show2" @click="overlayHide" z-index="999">
      <div class="prize-tip" @click.stop>
        <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/tanchuang_xiexie@2x.png">

      </div>
      <van-button
        @click="overlayHide"
        size="small" block
        class="btn-close" color="#ffffff" round
        style="background-color: rgba(0,0,0,0)"
        plain>我知道了
      </van-button>
    </van-overlay>


  </div>
</template>

<script>
import { getCryptoPhone } from '@api/activity'
import { getInfo, getWinList, sign, myWins } from '@api/cash'

export default {
  name: 'cash',
  data () {
    return {
      // 0 参与记录， 1规则
      checked: 0,

      signFlag: undefined,
      authFlag: undefined,
      ruleShow: false,

      // show 中奖相关
      show: false,
      show1: false,
      show2: false,
      showNum: undefined, // 第几次弹窗
      prizeVal: '',
      prizeTime: '',

      isIOS: false,
      winsFlag: undefined,
      showBar: false,
      prizeList: [],
      myWins: [],
      list: [],
      token: undefined,
      status: undefined,
      shareShow: false,
      signShow: false,
      info: '',
      img: '',
      time: '',
      cryptoPhone: '',
      firstFlag: 0,
      tenThousandMobile: undefined
    }
  },

  created () {
    // 停止下拉刷新 0 停止， 1 打开
    this.$bridge.callHandler('pullRefreshSwitch', 0, response => {
      console.log('response:', response)
    })
    this.token = localStorage.getItem('token')
    let u = navigator.userAgent
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端

    this.showBar = this.$route.query.showBar

    this.getInfo()
  },

  mounted () {
    // this.onLoad()
  },

  methods: {

    // 跳转邀工币明细
    toMingXi () {
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/coinsHist`,
        title: '邀工币'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 去实名
    toAuth () {
      if (this.token && this.token !== 'undefined') {
        let data = {
          url: '',//`${process.env.VUE_APP_BASE_HOST}/activity/cash`,
          msg: `请先进行实名认证`,
          isJump: '0',
          title: '预约报名'
        }
        this.$bridge.callHandler('jumpAuthentication', data, response => {
          console.log('response:', response)
        })
      } else {
        // 登录页面
        this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
          console.log('response:', response)
        })
      }
    },

    // 中奖弹窗关闭
    overlayHide () {
      if (this.show) {
        this.show = false
      }
      if (this.show1) {
        this.show1 = false
      }
      if (this.show2) {
        this.show2 = false
      }

      let that = this
      setTimeout(function () {
        if (that.showNum === 1 && that.prizeList.length === 2) {
          that.showNum = 2
          if (that.prizeList[1].prizeLevel == 0) {
            that.prizeTime = (that.prizeList[1].signDate.substring(0, 4) + '年' + that.prizeList[1].signDate.substring(4 + 1)).substring(0, 7) + '月' + that.prizeList[1].signDate.substring(7 + 1) + '日'
            that.show = true
          } else {
            that.prizeVal = that.prizeList[1].prizeName + that.prizeList[1].prizeNum + that.prizeList[1].prizeUnit
            that.prizeTime = (that.prizeList[1].signDate.substring(0, 4) + '年' + that.prizeList[1].signDate.substring(4 + 1)).substring(0, 7) + '月' + that.prizeList[1].signDate.substring(7 + 1) + '日'
            that.show1 = true
          }
        }
      }, 200)
    },

    // 首次进入以及中奖
    getInfo () {
      // 获取累计收入
      getInfo().then(res => {
          if (res.data.code === 200) {
            this.winsFlag = res.data.data.winsFlag
            this.signFlag = res.data.data.signFlag
            this.list = res.data.data.wins
            this.yesterdaySignFlag = res.data.data.yesterdaySignFlag
            this.prizeList = res.data.data.prizeList
            // 判断第一次进入弹窗
            if (res.data.data.firstFlag == 1) {
              debugger
              // if (this.list.length === 0 || this.prizeList.length === 0) {
              //   this.firstFlag = res.data.data.firstFlag
              // } else {
              if (this.prizeList.length > 0) {
                if (this.prizeList[0].prizeLevel == 0) {
                  this.prizeTime = (this.prizeList[0].signDate.substring(0, 4) + '年' + this.prizeList[0].signDate.substring(4 + 1)).substring(0, 7) + '月' + this.prizeList[0].signDate.substring(7 + 1) + '日'
                  this.show = true
                } else {
                  this.prizeVal = this.prizeList[0].prizeName + this.prizeList[0].prizeNum + this.prizeList[0].prizeUnit
                  this.prizeTime = (this.prizeList[0].signDate.substring(0, 4) + '年' + this.prizeList[0].signDate.substring(4 + 1)).substring(0, 7) + '月' + this.prizeList[0].signDate.substring(7 + 1) + '日'
                  this.show1 = true
                }
                this.showNum = 1
              } else if (this.list.length === 0 || this.yesterdaySignFlag === 0) {
                this.firstFlag = res.data.data.firstFlag
              } else if (this.yesterdaySignFlag === 1) {
                this.show2 = true
              }
            }
            // }

            if (this.firstFlag === 1 && this.signFlag === 0) {
              this.signShow = true
            }

            if (res.data.data.tenThousandPrize) {
              this.tenThousandMobile = res.data.data.tenThousandPrize.mobile
            }
            this.authFlag = res.data.data.authFlag
            this.status = res.data.data.status
            this.endTime = +new Date(res.data.data.endTime.replace(/\./g, '/'))
            // this.endTime = +new Date('2022/10/13 13:46:00')
            if (this.status === 1) {
              //定时器 每隔一秒变化一次
              this.initCountDown()
            }
          } else {
            this.$toastMsg(res.data.msg)
          }
        }
      )
    },

    // 我的参与记录与规则
    onRule () {
      document.body.style.position = 'fixed'
      document.body.style.overflow = 'hidden'
      this.ruleShow = true
      if (this.token && this.token !== 'undefined') {
        myWins().then(res => {
          if (res.data.code === 200) {
            this.myWins = res.data.data
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      }
    },

    closeRule () {
      document.body.style.position = ''
      document.body.style.overflow = ''
      this.ruleShow = false
    },

    // 获取用户加密手机号（用于分享）
    getCryptoPhone () {
      getCryptoPhone().then(res => {
        if (res.data.code === 200) {
          this.cryptoPhone = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 报名
    sign () {
      if (this.token && this.token !== 'undefined') {
        if (this.status === 0) {
          this.$toastMsg('活动已结束')
          return
        } else if (this.signFlag === 1) {
          this.$toastMsg('今日已报名')
          return
        }
        // 获取累计收入
        sign().then(res => {
          if (res.data.code === 200) {
            this.signFlag = 1
            this.signShow = false
            this.ruleShow = false
            document.body.style.position = ''
            document.body.style.overflow = ''
            this.$toastMsg('报名成功，等待明天10点开奖')
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      } else {
        // 登录页面
        this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
          console.log('response:', response)
        })
      }
    },

    // 初始化倒计时
    initCountDown () {
      let that = this
      setInterval(function () {
        that.countDown()
      }, 1000)
    },

    countDown () {
      let nowTime = +new Date() // 返回的是当前时间总的毫秒数
      let times = (this.endTime - nowTime) / 1000 // times是剩余时间总的秒数
      // 判断活动结束
      if (nowTime >= this.endTime) {
        this.status = 0
        return
      }
      let d = parseInt(times / 60 / 60 / 24) // 把秒数转换成天数  （parselnt把得到的数转换为整数）
      d = d < 10 ? '0' + d : d//这里为了让时间数好看一点，比如把4天改成04天，所以加了三元判定，下面也是如此；
      let h = parseInt(times / 60 / 60 % 24) //时
      h = h < 10 ? '0' + h : h
      let m = parseInt(times / 60 % 60) //分
      m = m < 10 ? '0' + m : m
      let s = parseInt(times % 60) // 秒
      s = s < 10 ? '0' + s : s

      this.time = (d + '天' + h + '时' + m + '分' + s + '秒')
      // return d + '天' + h + '时' + m + '分' + s + '秒' //返回函数计算出的值
    }
    ,

    // 获取页面滚动距离
    handleScroll (e) {
      let el = e.target

      //判断是否到达div容器底部
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        // this.$toastMsg('滚动')
        //调用后台接口
        // this.onLoad()
      }
    }
    ,

    onClickLeft () {
      // 返回上个页面
      this.$bridge.callHandler('back', response => {
        console.log('response:', response)
      })
    },

    // 分享
    toShare () {
      if (this.token && this.token !== 'undefined') {
        this.getCryptoPhone()
        this.shareShow = true
      } else {
        // 登录页面
        this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
          console.log('response:', response)
        })
      }
    },

    // 获取获奖记录
    onLoad () {
      getWinList({}).then(res => {
        if (res.data.code === 200) {
          // this.myWin = res.data.data.myWin
          this.list = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
    ,

    // 分享微信
    toWechat () {
      // alert('分享微信')
      const data = {
        title: '邀请下载',
        content: '邀请您和我一起使用邀工网，发活、找活一键触达',
        type: 0,//0-微信；1-朋友圈
        path: '/pages/getJob/index?cryptoMobile=' + this.cryptoPhone,//小程序地址
        url: '/coinsInvitation',
      }
      this.$bridge.callHandler('inviteFriend', data, response => {
        console.log('response:', response)
      })
    }
    ,

    // 分享朋友圈
    toPengyouquan () {
      // alert('分享朋友圈')
      const data = {
        title: '邀请您和我一起使用邀工网，发活、找活一键触达',
        content: '邀请您和我一起使用邀工网，发活、找活一键触达',
        type: 1,//0-微信；1-朋友圈
        path: '/pages/getJob/index?cryptoMobile=' + this.cryptoPhone,//小程序地址
        url: '/coinsInvitation',
      }
      this.$bridge.callHandler('inviteFriend', data, response => {
        console.log('response:', response)
      })
    }
    ,

    // 面对面分享
    toMianduimian () {
      // this.enterRouter('coinsInvitation')
      const data = {
        title: '邀工网',
        url: `${process.env.VUE_APP_BASE_HOST}/coinsInvitation`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    }
    ,

    // 跳转邀请好友规则
    toInvitationRule () {
      const data = {
        title: '邀请好友规则',
        url: `${process.env.VUE_APP_BASE_HOST}/staticPages/invitationRule`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    }
    ,

    // 下载图片
    onScreenshot () {
      // 滚动到顶部（关闭筛选弹窗后可能不会回到顶部）
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth'
      })

      let that = this
      setTimeout(function () {
        that.$bridge.callHandler('screenshot', response => {
          console.log('response:', response)
        })
      }, 500)
    }
    ,

  }
}
</script>

<style scoped lang="less">

.cash {
  min-height: 100%;
  background-color: #F1383DFF;

  //.wrapper {
  //  display: flex;
  //  align-items: center;
  //  justify-content: center;
  //  height: 100%;
  //}

  .btn_qubaoming {
    float: right;
    height: 24px;
    width: 70px;
    margin-top: 3px;
  }

  .checked {
    color: #BC9A49FF;
  }

  .add-num {
    vertical-align: 7%;
  }

  .van-nav-bar {
    background-color: #FD3043;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-icon {
    color: #FFFFFF !important;
  }

  .share-tip {
    //noinspection CssInvalidPseudoSelector
    ::v-deep .van-icon {
      color: #009CFF !important;
    }
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-nav-bar__title {
    color: #FFFFFF !important;
  }

  .rule-title {
    padding-top: 12px;
    font-size: 15px;
  }
}

.btn-tip-close {
  float: right;
  font-size: 30px;
  margin-top: -140px;
  right: 172px;
}

.btn-close {
  margin-top: -160px;
  left: 134px;
  width: 110px;
}

.prize-num-tip {
  position: fixed;
  border-radius: 10px;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  margin: 30% auto;

  .prize-num-img {
    width: 100%;
    height: 410px;
  }

  .prize-num {
    bottom: -70px;
    width: 100%;

    .prize-ten-time {
      font-size: 13px;
      color: #f3b6af;
      margin-bottom: 160px;
    }

    .prize-num-time {
      font-size: 13px;
      color: #f5afa9;
      margin-bottom: 40px;
    }

    .van-icon {
      color: #f5afa9 !important;
      vertical-align: -10%;
    }

    p {
      font-size: 38px;
      color: #FFEF9EFF;
      margin-bottom: 8px;
      font-weight: bold;
    }

    a {
      font-size: 13px;
      color: #f5afa9;
    }
  }

  .btn-num-close {
    margin-top: 80px;
    left: 122px;
    width: 110px;
  }
}

.prize-tip {
  border-radius: 10px;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  width: 310px;
  //height: 202px;
  margin: 50% auto;
}

.iOS-rule-tip{
  padding:12px;
  font-size: 12px;
  background-color: #F1383DFF;
  margin-top:-48px;
}

.iOS-rule-tip-text{
  font-size: 12px;
  color: #FFFFFF;
  opacity: 0.7;
}

.overlay-tip {
  border-radius: 10px;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  width: 310px;
  //height: 202px;
  background-color: #FDF7E8FF;
  margin: 50% auto;

  p {
    line-height: 30px;
  }

  .overlay-tip-title {

    img {
      margin-left: 65px;
      width: 160px;
      height: 31px;
      margin-top: -25px
    }
  }

  .overlay-tip-text {
    padding: 30px 0 16px 0;
  }

  .rule-text {
    width: 100%;
    justify-content: space-around;
    font-size: 13px;
    margin-top: 12px;
    padding: 10px 12px;
    background-color: #FDF7E8FF;
    border-radius: 8px;
    height: 280px;
    //position: fixed;
    overflow-y: auto;

    p {
      line-height: 23px;
    }
  }

  .my-wins {
    li {
      font-size: 14px;
      line-height: 32px;
    }
  }

  .overlay-tip-btn {
    width: 117px;
    height: 32px;
    margin-bottom: 16px;
  }
}

.overlay-rule {
  background-color: #FFFFFF;
}

.bg-img {
  width: 100%;
  height: 100%;
}

.btn-rule {
  margin-top: 140px;
  float: right;
  width: 100px;
  height: 24px;
  right: 0;
}

.huodong-div {
  //background: linear-gradient(1deg, #fe7653 0%, #FD3043 100%);
  background-color: #F1383DFF;
  height: 500px;
  width: 100%;
}

.huodong-img {
  //padding-top: constant(safe-area-inset-top);
  //padding-top: env(safe-area-inset-top);
  width: 100%;
  //height: 637px;
  background-size: contain;
  background-image: url('https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/wanyuan_title@2x.png');
  text-align: center;
  //position: absolute;
  float: right;
  //top: 0;
}

.tip-cash-div {
  height: 92px;

  .tip-cash-content {
    display: flex;
    margin-top: 8px;
  }
}

.tip-cash {
  margin: 0 12px;
  width: 351px;
  height: 92px;
  background-size: contain;
  background-image: url('https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/cash/bg_dajiang@2x.png');
  text-align: center;
  position: absolute;

  .user {
    color: #BC9A49FF;
    font-size: 15px;
  }

  .tip {
    color: #BC9A49FF;
    font-size: 17px;
    margin-top: 5px;
  }

  .tip-ten {
    font-weight: bold;
    color: #FF4C39FF;
    font-size: 18px;
  }

  .dajiang {
    height: 78px;
    width: 135px;
  }
}

.cash-time {
  height: 34px;
  margin-top: 276px;
  text-align: center;
  width: 100%;
  color: #FFEF9EFF;
  font-size: 12px;
}

.qr-code {
  margin: 140px auto 0;
  width: 100%;
  text-align: center;

  img {
    border-radius: 3px;
    border: 2px solid #FACE78;
    background-color: #FFFFFF;
    padding: 3px;
    margin: auto;
    text-align: center;
    height: 155px;
    width: 155px;
  }
}

.bottom-img {
  padding: 10px 41px;
  display: flex;
  width: 100%;
}

.btn_fab {
  height: 36px;
  margin: 20px 13px;
  //padding-top: 15px;
  //padding-bottom: 10px;
  width: 120px;
}


.hist-list {
  padding-top: 36px;
  background-color: #F1383DFF;

  .hist-div {
    margin: 0 12px;
    padding: 12px 12px 6px 12px;
    background: #FDF7E8FF;
    border-radius: 8px;
    opacity: 1;

    .prize-content {
      padding-top: 14px;

      img {
        margin-bottom: 8px;
      }
    }

    .content {
      padding-top: 22px;
    }

    .no-1 {
      height: 20px;
      width: 20px;
      margin-top: 2px;
    }

    .f15 {
      font-size: 15px;
    }

    .w-100 {
      width: 100%;
      padding-left: 10px;
      margin: auto;
      text-align: left;
      line-height: 24px;
    }

    .right-icon {
      width: 70px;
      height: 24px;
      padding: 0;
      margin: auto;
      margin-left: 20px;

      .van-button__content {
        font-size: 14px;
        width: 70px;
      }
    }

    .is-auth {
      margin: auto;
      width: 54px;
      height: 16px;
    }
  }
}

.bt-60 {
  padding-bottom: 60px;
}

.hist-content {
  min-height: 100px;
  width: 100%;
  position: relative;

  .share_title_yaoqing {
    margin-top: -28px;
    margin-left: 84px;
    width: 160px;
    height: 31px;
    position: absolute;
  }

  .hist-title {
    text-align: left;
    width: 100%;
    line-height: 50px;
    height: 50px;
    opacity: 1;
    font-size: 14px;
    font-weight: bold;

    .van-icon {
      font-size: 20px;
      vertical-align: -20%;
    }

    span {
      font-size: 13px;
      color: #FFB111FF;
    }
  }
}

.blank-tip-title {
  padding: 19px 0;
  font-size: 20px;
}

.blank-tip-info {
  color: #666666FF;
  padding: 0 50px;
  font-size: 16px;
}

.prize-time {
  font-size: 12px;
  color: #999999FF;
  padding: 15px 0 10px 0;
}

.list-content {
  width: 100%;
  text-align: left;
  max-height: 400px;
  overflow: auto;
  white-space: nowrap;

  .list-tip {
    color: #BC9A49FF;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 18px;
  }

  .list-tip-time {
    color: #333333FF;
    font-size: 14px;
  }

  li {
    padding: 15px 10px;
    background-color: #FEFBF3FF;
    margin-bottom: 8px;
    border-radius: 5px;
  }

  .list-icon {
    margin-right: 8px;
    width: 20px;
    height: 20px;
    margin-top: 2px;
  }

  p {
    font-size: 14px;

    span {
      font-size: 16px;
      color: #FFB111FF;
    }
  }

}

.share-popup {
  margin: 50% auto;
  background-size: contain;
  width: 300px;
  height: 375px;
  background-image: url('../../../assets/images/coins/coins_share.png');

  .share-popup-content {
    padding: 10px 20px;
  }

  .share-title {
    font-size: 16px;
    padding-top: 130px;
  }

  .share-icon {
    padding-top: 20px;

    img {
      margin: auto;
      height: 50px;
      width: 50px;
    }

    .text {
      margin-top: 5px;
      font-size: 14px;
    }
  }

  .share-tip {
    font-size: 14px;
    padding-top: 20px;
  }

  .van-icon {
    vertical-align: -10%
  }
}

.bt-20 {
  padding-bottom: 20px !important;
}

</style>
